import { message } from "antd";
import { createSlice } from "@reduxjs/toolkit";
import {jwtDecode} from "jwt-decode";
import { IAuthState } from "@types";
import { authApi } from "@services";

const initialState: IAuthState = {
  user: null,
  token: {
    access: null,
    refresh: null,
  },
  permissions: [],
  is_one_time_password: false,
  applications: [],
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(authApi.endpoints.logout.matchPending, (state, action) => {
        state.user = null;
        message.success(`User has been successfully logout`);
      })
      .addMatcher(
        authApi.endpoints.login.matchFulfilled,
        (state, { payload }) => {
          if (payload?.data?.is_one_time_password) {
            state.is_one_time_password = payload?.data?.is_one_time_password;
            state.token.access = payload?.data?.token;
          } else {
            state.is_one_time_password = payload?.data?.is_one_time_password;
            state.user = payload?.data?.user;
            state.token = payload?.data?.token;
            state.permissions = !payload?.data?.permissions?.length
              ? ["all"]
              : payload?.data?.permissions;
            state.applications = payload?.data?.applications;
          }
        }
      )
      // .addMatcher(
      //   authApi.endpoints.verify.matchFulfilled,
      //   (state, { payload }) => {
      //     if (payload?.data?.is_one_time_password) {
      //       state.is_one_time_password = payload?.data?.is_one_time_password;
      //       state.token.access = payload?.data?.token;
      //     } else {
      //       state.is_one_time_password = payload?.data?.is_one_time_password;
      //       state.user = payload?.data?.user;
      //       state.token = payload?.data?.token;
      //       state.applications =
      //         payload?.data?.user?.company?.applications || [];
      //       state.permissions = !payload?.data?.permissions?.length
      //         ? ["all"]
      //         : payload?.data?.permissions;
      //     }
      //   }
      // );
       .addMatcher(
  authApi.endpoints.verify.matchFulfilled,
  (state, { payload }) => {
    try {
      // 🧩 Decode JWT access token
      const token = payload?.data?.token?.claims
      const claims: any = token ? jwtDecode(token) : {};

      // 🧠 Merge decoded role into user
      const updatedUser = {
        ...payload?.data?.user,
        role: claims?.role, 
      };

      const permissions = claims?.permissions

      // ✅ Handle one-time password vs normal verification
      if (payload?.data?.is_one_time_password) {
        state.is_one_time_password = true;
        state.token.access = token;
      } else {
        state.is_one_time_password = false;
        state.user = updatedUser;
        state.token = payload?.data?.token;
        state.applications =
          updatedUser?.company?.applications || [];
        state.permissions = !permissions?.length
          ? ["all"]
          : permissions;
      }
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }
);
  },
});

export default slice.reducer;
